module.exports = __webpack_public_path__ + "static/media/chito_khelna_aau.d03d0adf.ogg";